export class PersonaFisicaBaseDTO {
	codTipoDelega: string;
	codiceFiscale: string;
	cognome: string;
	idPersona: string;
	idRisorsa: string;
	idRuolo: string;
	nome: string;
	tipoDelega: string;
	validata: string;
}

export function nuovaPFBase() : PersonaFisicaBaseDTO {
	const newPF: PersonaFisicaBaseDTO = new PersonaFisicaBaseDTO();
	newPF.cognome = 'nuova-persona-fisica';
	newPF.nome = '';
	newPF.idPersona = 'nuovo';
	newPF.codTipoDelega = ''
	return newPF;
}
